import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      d: "M14.067 8.995c0 .259-.103.518-.3.694l-8.118 8.02a.92.92 0 0 1-.663.28.93.93 0 0 1-.953-.942c0-.26.103-.498.28-.674l8.113-7.938v1.109L4.312 1.606a.91.91 0 0 1-.28-.673.93.93 0 0 1 .954-.943c.26 0 .487.103.674.28l8.107 8.02c.197.197.3.435.3.705"
    }, null, -1)
  ])))
}
export default { render: render }